export var TypeActionTutorial;
(function (TypeActionTutorial) {
    TypeActionTutorial["Select"] = "Tutorial > Select";
    TypeActionTutorial["Complete"] = "Tutorial > Complete";
    TypeActionTutorial["Init"] = "Tutorial > Init";
    TypeActionTutorial["Welcome"] = "Tutorial > Welcome";
    TypeActionTutorial["HarvestClickAcre"] = "Tutorial > Harvest Click Acre";
})(TypeActionTutorial || (TypeActionTutorial = {}));
export var actionTutorialSelect = function (tutorialStep) { return ({
    tutorialStep: tutorialStep,
    type: TypeActionTutorial.Select,
}); };
export var actionTutorialInit = function (tutorialStep) { return ({
    tutorialStep: tutorialStep,
    type: TypeActionTutorial.Init,
}); };
export var actionTutorialComplete = function () { return ({ type: TypeActionTutorial.Complete }); };
export var actionTutorialHarvestClickAcre = function () { return ({
    type: TypeActionTutorial.HarvestClickAcre,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/actionTutorial.ts
// module id = 88
// module chunks = 3